import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../Axios";

export const createPaymentIntent = createAsyncThunk(
  "order/createPaymentIntent",
  async (orderData, { rejectWithValue }) => {
    try {
      const response = await axios.post("payment/create-checkout-session", orderData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const updateFeedback = createAsyncThunk("/order/feedback",
  async({orderId , formData} , {rejectWithValue})=>{
    try {
      const response = await axios.post(`/order/feedback?orderId=${orderId}` , formData ,{
        headers: { "Content-Type": "multipart/form-data" },
      });

      return (
        {
          order : response?.data?.order,
          message : "Updated feedback"
        }
      )
    } catch (error) {
        return rejectWithValue(error.response?.data || error?.message);
    }
  }
)


export const fetchOrders = createAsyncThunk(
  "order/getAllOrders",
  async (_,{ rejectWithValue }) => {
    try {
      const response = await axios.get("/order/getAllOrders");
      return response.data.orders;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);


const orderSlice = createSlice({
  name: "order",
  initialState: {
    order: null,
    paymentIntent: null,
    loading: false,
    error: null,
    orders:[]
  },
  reducers: {
    resetOrder(state) {
      state.order = null;
      state.loading = false;
      state.error = null;
      state.paymentIntent = null;
      
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(createPaymentIntent.pending, (state) => {
        state.loading = true;
      })
      .addCase(createPaymentIntent.fulfilled, (state, action) => {
        state.loading = false;
        state.paymentIntent = action.payload;
      })
      .addCase(createPaymentIntent.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchOrders.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchOrders.fulfilled, (state, action) => {
        state.loading = false;
        state.orders = action.payload;
      })
      .addCase(fetchOrders.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});
export const { resetOrder } = orderSlice.actions;

export default orderSlice.reducer;
